<template>
  <div id="header-wrap">
    <div class="header" :class="{active: isActive}">
      <a class="logo" href="index.html">
        <img src="./logo.png" alt="" />
      </a>
      <div class="nav">
        <ul>
          <!--  :class="{active: item.active}" -->
          <li :class="{active: item.active}" :key="index" v-for="(item, index) in navList"><strong></strong><a :href="item.page.page+ '?rootId='+item.id">{{item.page.name}}</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Url from 'static/baseUrl'
import axios from 'axios'
export default {
  name: 'HelloWorld',
  data () {
    return {

      navList: [],

      isActive: false,

    }
  },
  created(){
    // 获取行业新闻导航的id（老版官网接口，目前新官网没有，先用老版接口获取id。。。）
    // axios.get('/cms/api/column/list').then(res => {
    //   if (res && res.data.success && res.data.data.length) {
    //     res.data.data.forEach((item, index) => {
    //       if (item.name == '行业新闻') {
    //         sessionStorage.articleRootId = item.id
    //         return
    //       }
    //     })
    //   }
    // })

  },
  mounted() {
    axios.get('http://www.starsine.cn:8088/star-module-interface/cms/api/column/list').then(res => {
      if (res && res.data.success && res.data.data.length) {
        res.data.data.forEach((item ,index) => {
          item.active = false
        })
        this.navList = res.data.data
      }
    }).then(() => {
      const activeUrl = location.pathname
      this.navList.forEach((item, index) => {
        if (activeUrl == '/') {
          this.navList[0].active = true
        }
        if (activeUrl.includes(item.page.page)) {
          item.active = true
          return
        } else{
          if (activeUrl.includes('article.html')) {
            if (item.page.page == 'new.html') {
              item.active = true
            }
          }
        }
      })
    })



    const that = this
    this.$nextTick(() => {
      window.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let IndexBannerHeight
        let BannerHeight
        let breadcrumbHeight
        if (document.querySelector('.swiper-main-boxs')) {
          IndexBannerHeight = document.querySelector('.swiper-main-boxs').offsetHeight
        } else if (document.querySelector('.banner_boxs')) {
          BannerHeight = document.querySelector('.banner_boxs').offsetHeight // 楼梯页面banner
        } else if (document.querySelector('.breadcrumb')) {
          breadcrumbHeight = document.querySelector('.breadcrumb').offsetHeight
        }

        if (IndexBannerHeight) {
          if (scrollTop>=IndexBannerHeight) {
            that.isActive = true
          } else {
            that.isActive = false
          }
        } else if (BannerHeight) {
          if (scrollTop >= BannerHeight) {
            that.isActive = true
          } else {
            that.isActive = false
          }
        } else if (breadcrumbHeight) {
          if (scrollTop >= breadcrumbHeight) {
            that.isActive = true
          } else {
            that.isActive = false
          }
        }

      })
    })



  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
  #header-wrap {
    margin-top: 72px;
  }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 72px;
    line-height: 72px;
    background: #ffffff;
    /* padding: 0 80px; */
    padding: 0 220px;
    box-sizing: border-box;
    a.logo {
      float: left;
      position: relative;
      height: 100%;
      width: 144px;
      img {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: 106px;
        height: 44px;
      }
    }
    .nav {
      float: right;
      height: 100%;
      ul {
        height: 100%;
        li.active {
          font-weight: bold;
          a {
            color: #0EAEE5;
          }
          strong {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background-color: #0EAEE5;
          }
        }
        li {
          float: left;
          position: relative;
          height: 100%;
          /* margin: 0 15px; */
          margin-right: 30px;
          font-size: 16px;
          padding-top: 14px;
          box-sizing: border-box;
          cursor: pointer;
          a {
            /* font-weight: 500; */
            font-weight: bold;
            color: #9196A1;
          }

        }
        li:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .header.active {
    box-shadow:0px 4px 8px 0px rgba(216,216,216,0.5);
  }

  @media screen and (max-width: 1440px) {
    .header {
      padding: 0 120px;
    }
  }

  @media screen and (max-width: 1258px) {
    .header {
      padding: 0 60px;
    }
  }

  @media screen and (max-width: 1100px) {
    .header {
      padding: 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue